// src/components/Mounter.tsx
import { useRef } from "react";
import { useNovuUI } from "../context/NovuUIContext.js";
import { useIsomorphicLayoutEffect } from "../hooks/internal/useIsomorphicLayoutEffect.js";
import { jsx } from "react/jsx-runtime";
function Mounter({ name, props, bare }) {
  const { novuUI } = useNovuUI();
  const ref = useRef(null);
  const handleRef = useRef(null);
  const latestProps = useRef(props);
  latestProps.current = props;
  useIsomorphicLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    handleRef.current = novuUI.mountComponent({ name, element, props: latestProps.current, bare });
    return () => {
      handleRef.current?.unmount();
      handleRef.current = null;
    };
  }, [novuUI, name, bare]);
  useIsomorphicLayoutEffect(() => {
    handleRef.current?.update(props);
  }, [props]);
  return /* @__PURE__ */ jsx("div", { ref, style: bare ? { display: "contents" } : void 0 });
}
export {
  Mounter
};
//# sourceMappingURL=Mounter.js.map